import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectAuthAPI } from '../../api/interface';
import { TYPES as API_TYPES } from '../../api/interface/bind';
import type { IAuthManagerArguments, IAuthManagerInstantiator } from '../interface/auth';
import {
    bindAuthManager,
    injectAuthManager,
    TYPES as CONTROLLER_TYPES,
    unbindAuthManager,
} from '../interface/bind';
import authImpl from './auth';

function _build(container: IContainer): Readonly<IAuthManagerInstantiator> {
    const authAPI = injectAuthAPI(container);

    return Object.freeze({
        open: (args: IAuthManagerArguments) => authImpl.open(authAPI, args),
        expand: (data: string) => authImpl.expand(authAPI, data),
    });
}

export default buildBindable<IAuthManagerInstantiator>({
    id: CONTROLLER_TYPES.IAuthenticationManager,
    dependencies: [API_TYPES.IAuthAPI],
    bind: bindAuthManager,
    remove: unbindAuthManager,
    build: container => Promise.resolve(_build(container)),
    inject: injectAuthManager,
});
